export default __webpack_public_path__ + "static/media/poushak-stand.c88c5667.png";